import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { AddCartLinesApiParameter, UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCartState, getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";

import {
    chain,
    PopulateAddLineCollectionApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/PlaceOrder";
import { CartLineModel, CartModel } from "@insite/client-framework/Types/ApiModels";
import { addToCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandlerDiscreteParameter<
    { order?: CartModel } & HasOnSuccess & HasOnError<string>,
    AddCartLinesApiParameter,
    CartModel,
    { updateCartApiParameter: UpdateCartApiParameter }
>;

export const PopulateAddLineCollectionApiParameterExtended: HandlerType = props => {
    const state = props.getState();
    const order = props.parameter.order ?? getCartState(state, state.pages.savedOrderDetails.cartId).value;
    if (!order) {
        throw new Error("PlaceOrder was called but there was no order");
    }

    let availableLines = order.cartLines!.filter((cartLine: CartLineModel) => cartLine.canAddToCart);
    // remove zero pricing item as add promotion applied by backend on cart page
    availableLines = availableLines.filter(
        (cartLine: CartLineModel) =>
            typeof cartLine.pricing?.actualPrice === "number" && cartLine.pricing.actualPrice !== 0,
    );
    props.apiParameter = {
        cartId: API_URL_CURRENT_FRAGMENT,
        cartLineCollection: {
            cartLines: availableLines,
        },
    } as AddCartLinesApiParameter;
};

export const trackAddtoCartEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
    if (props.apiParameter?.cartLineCollection?.cartLines && cart) {
        const newItem = props.apiParameter?.cartLineCollection?.cartLines.map(item => {
            return {
                item_name: item?.shortDescription,
                item_id: item.productName,
                quantity: item.qtyOrdered,
                price: item.pricing?.unitNetPrice,
                item_brand: item?.brand?.name,
            };
        });

        // Calculate total value as sum of (price * quantity) for each item
        const totalValue = props.apiParameter.cartLineCollection.cartLines.reduce((acc, item) => {
            const price = item.pricing?.unitNetPrice ?? 0;
            const qty = item.qtyOrdered ?? 0;
            return acc + price * qty;
        }, 0);
        
        addToCartEvent({
            event: "add_to_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                value: totalValue,
                items: [...newItem],
            },
        });
    }
};

addToChainAfter(chain, SendDataToApi, trackAddtoCartEvent);
replaceInChain(chain, PopulateAddLineCollectionApiParameter, PopulateAddLineCollectionApiParameterExtended);